module.exports = __webpack_public_path__ + "img/Sorida.55513482.png";